import { InferType, array, boolean, number, object, string } from "yup";
import { SiteSchema } from "./Site";
import moment from "moment-timezone";

export type Message = InferType<typeof MessageSchema>;
export type UpsertMessage = InferType<typeof UpsertMessageSchema>;
export enum MessageType {
    HTML = "HTML",
    TEXT = "TEXT",
}

export enum TagType {
    SPAM = "SPAM",
    LEAD_BU = "LEAD_BU",
    LEAD_CONTENT = "LEAD_CONTENT",
    WAITING_PAYMENT = "WAITING_PAYMENT",
    PAID = "PAID",
    IN_PROGRESS = "IN_PROGRESS",
    DELIVERED = "DELIVERED",
}

export type TTagType = keyof typeof TagType;

export const ChatSchema = object({
    message: string().required(),
    mailFrom: string().required(),
    receivedAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;

            return moment(v1.date).tz("Europe/Paris").format("YYYY-MM-DD HH:mm:ss");
        }),

    attachments: array().of(string().required()).notRequired(),
});

export const MessageSchema = object({
    id: number().required(),
    moneySite: SiteSchema.required(),
    mailFrom: string().required(),
    subject: string().required(),
    chat: array().of(ChatSchema.required()).required(),
    tag: string<TTagType>().nullable(),
    createdAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;

            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    updateAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;

            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    active: boolean().required(),
    lastMessageDate: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD HH:mm:ss");
        }),
});

export const UpsertMessageSchema = MessageSchema.omit([
    "id",
    "moneySite",
    "createdAt",
    "updateAt",
    "active",
]).concat(
    object({
        moneySiteId: number().required(),
        newMessage: string(),
    })
);
